import type { ClipName } from '../anim/clips';

// State — the Actor's discrete behavioural mode. The State machine picks a State
// each frame from the body + inputs; the State maps to the clip the Rig plays.
// `attack` and `hit` are TIMED, non-locomotion states that own the Actor until
// their clip finishes (so a reaction actually reads on screen before movement
// resumes).

export type ActorState = 'idle' | 'run' | 'jump' | 'fall' | 'attack' | 'hit';

/** State → the baked clip the Rig should be playing in that State. jump and
 *  fall share the airborne `jump` clip in the slice. */
export function clipForState(state: ActorState): ClipName {
  switch (state) {
    case 'idle': return 'idle';
    case 'run': return 'walk';
    case 'jump':
    case 'fall': return 'jump';
    case 'attack': return 'attack';
    case 'hit': return 'hit';
  }
}

/** States that can't be interrupted by locomotion until their clip runs out. */
export function isLocked(state: ActorState): boolean {
  return state === 'attack' || state === 'hit';
}
